import { createFileRoute } from '@tanstack/react-router';
import NewsEntryEdit from '~/containers/NewsEntryEdit';

export const Route = createFileRoute('/news-entries/$newsEntryId')({
  component: NewsEntryEdit,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
